// REACT DEFAULTS & IMPORTS
import { DefaultLinks, BusinessLinks, PaymentLinks } from './data'

// COMPONENTS
import SidebarLink from '../SidebarLink'
import VirtualAccount from '../../assets/images/icon_virtual_account.png'
import { FiToggleLeft } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'
import { BsHddStack } from 'react-icons/bs'

// STYLES
import styles from './Sidebar.module.scss'

const Sidebar = () => {
	return (
		<aside className={styles.sidebarContainer}>
			<div className={styles.sidebar}>
				<div className={styles.DefaultLinks}>
					{DefaultLinks.map((data) => {
						return (
							<SidebarLink
								key={data.id}
								src={data.img}
								alt={data.alt}
								text={data.text}
							/>
						)
					})}
				</div>
				<div className={styles.BusinessLinks}>
					<h4 className={styles.BusinessLinksTitle}>BUSINESS</h4>
					{BusinessLinks.map((data) => {
						return (
							<SidebarLink
								key={data.id}
								src={data.img}
								alt={data.alt}
								text={data.text}
							/>
						)
					})}
				</div>
				<div className={styles.PaymentLinks}>
					<h4 className={styles.PaymentLinksTitle}>PAYMENTS</h4>
					{PaymentLinks.map((data) => {
						return (
							<SidebarLink
								key={data.id}
								src={data.img}
								alt={data.alt}
								text={data.text}
							/>
						)
					})}

					<div className={styles.VirtualAccountLinks}>
						<div className={styles.SideBarLink}>
							<img
								className={styles.VirtualAccountLogo}
								src={VirtualAccount}
								alt="accounts"
							/>
							<div className={styles.flex_column}>
								<p className={styles.linkText}>Virtual Accounts</p>
								<small className={styles.new}>New</small>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className={styles.UtilityLinksContainer}>
				<div className={`${styles.SideBarLink} ${styles.UtilityLinks}`}>
					<div className={styles.UtilityLink}>
						<FiToggleLeft />
						<p>Live Mode</p>
					</div>
					<div className={styles.UtilityLink}>
						<IoSettingsOutline />
						<p>Settings</p>
					</div>
					<div className={styles.UtilityLink}>
						<BsHddStack />
						<p>Audit logs</p>
					</div>
				</div>
			</div>
		</aside>
	)
}

export default Sidebar
